import { CSV_TEMPLATE_IMPORT_SUCCESS, CSV_TEMPLATE_IMPORT_ERROR }  from '../../actions';

const initialState = {
}

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 

    switch(action.type) {
        
        case CSV_TEMPLATE_IMPORT_SUCCESS: 
            if(response.status===200){
                return {
                    ...state, 
                    csvTemplateData: response.data,
                    csvTemplateDataStatus: response.status,  
                    csvTemplateDataActivity:CSV_TEMPLATE_IMPORT_SUCCESS+timeVar,     
                };
            }else {
                return {
                    ...state,  
                    csvTemplateDataStatus: response.status,  
                    csvTemplateDataActivity:CSV_TEMPLATE_IMPORT_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }   

        case CSV_TEMPLATE_IMPORT_ERROR: 
            return {
                ...state,  
                downloadStatus: response.status,  
                downloadActivity:CSV_TEMPLATE_IMPORT_ERROR+timeVar, 
                errorData:response.data                              
            };

        default:
            return state;

    }
}